export const buildLineKey = (varietyId, priceIndex) => `${varietyId}:${priceIndex}`;

const toInteger = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number.parseInt(value, 10);
  return Number.isInteger(parsed) ? parsed : null;
};

export const resolveCurrentPriceIndexForItem = (item, variety) => {
  const prices = Array.isArray(variety?.VarietyPrices) ? variety.VarietyPrices : [];
  const varietyPriceId = toInteger(item?.varietyPriceId);
  if (Number.isInteger(varietyPriceId) && prices.length) {
    const byId = prices.findIndex((price) => Number(price?.id) === varietyPriceId);
    if (byId >= 0) return byId;
  }

  const fallbackIndex = toInteger(item?.priceIndex);
  if (!Number.isInteger(fallbackIndex)) return 0;
  if (!prices.length) return fallbackIndex;
  return fallbackIndex >= 0 && fallbackIndex < prices.length ? fallbackIndex : 0;
};

export const getDefaultCartIdentityKey = (entry) => {
  if (entry?.cartLineId) return String(entry.cartLineId);
  return buildLineKey(entry?.varietyId, entry?.priceIndex);
};

export const sortLineItemsByCartIdentity = (
  items,
  orderData = [],
  getIdentityKey = getDefaultCartIdentityKey
) => {
  const orderIndexByKey = new Map();
  (orderData || []).forEach((entry, index) => {
    if (
      !entry?.cartLineId
      && (!Number.isInteger(entry?.varietyId) || !Number.isInteger(entry?.priceIndex))
    ) {
      return;
    }
    const key = getIdentityKey(entry);
    if (!orderIndexByKey.has(key)) orderIndexByKey.set(key, index);
  });

  return [...(items || [])].sort((a, b) => {
    const keyA = getIdentityKey(a);
    const keyB = getIdentityKey(b);
    const orderA = orderIndexByKey.get(keyA);
    const orderB = orderIndexByKey.get(keyB);
    const hasOrderA = Number.isInteger(orderA);
    const hasOrderB = Number.isInteger(orderB);
    if (hasOrderA && hasOrderB) return orderA - orderB;
    if (hasOrderA) return -1;
    if (hasOrderB) return 1;

    const varietyA = Number(a?.varietyId) || 0;
    const varietyB = Number(b?.varietyId) || 0;
    if (varietyA !== varietyB) return varietyA - varietyB;
    const priceIndexA = Number(a?.priceIndex) || 0;
    const priceIndexB = Number(b?.priceIndex) || 0;
    return priceIndexA - priceIndexB;
  });
};

export const orderAndIndexLineItems = (
  items,
  orderData = [],
  getIdentityKey = getDefaultCartIdentityKey
) =>
  sortLineItemsByCartIdentity(items, orderData, getIdentityKey).map((item, lineIndex) => ({
    ...item,
    lineIndex,
  }));

export const normalizeBarcodeValue = (value) => {
  if (value === null || value === undefined) return null;
  const normalized = String(value).trim();
  return normalized === '' ? null : normalized;
};

export const varietySupportsBarcodePriceTypeSelection = (variety, isSellablePrice) => {
  const isSellable = typeof isSellablePrice === 'function' ? isSellablePrice : Boolean;
  const prices = (variety?.VarietyPrices || []).filter((price) => isSellable(price));
  if (prices.length < 2) return false;
  const barcodes = prices.map((price) => normalizeBarcodeValue(price?.barcode));
  if (!barcodes.length || barcodes.some((barcode) => !barcode)) return false;
  return new Set(barcodes).size === 1;
};
